import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import { deviceVerification, IDeviceVerificationState } from '../Device/Verification/deviceVerificationReducers';

export interface IManagementState {
	deviceVerification: IDeviceVerificationState;
}

export const managementReducer: Reducer<IManagementState> = combineReducers<IManagementState>({
	deviceVerification,
} as ReducersMapObject);
